import { render, staticRenderFns } from "./AutoEnrollmentSettings.vue?vue&type=template&id=329ed130"
import script from "./AutoEnrollmentSettings.vue?vue&type=script&lang=js"
export * from "./AutoEnrollmentSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports